import { map, reject } from 'lodash';
import { captureMessage } from 'lib/common/logger';
import { getSeatSelector, getSeatSelectorDisambiguated } from 'lib/seats/seatFinders';

function processLargeArrayAsync(array, fn, maxTimePerChunk, context) {
    context = context || window;
    maxTimePerChunk = maxTimePerChunk || 200;
    var index = 0;

    function doChunk() {
        var startTime = new Date().getTime();
        while (index < array.length && (new Date().getTime() - startTime) <= maxTimePerChunk) {
            fn.call(context, array[index], index, array);
            ++index;
        }
        if (index < array.length) {
            setTimeout(doChunk, 1);
        }
    }
    doChunk();
}

/**
 * WARNING: For large data-sets this function is the *main* bottleneck.
 * This function is unavoidable as it is used to map seat data to DOM nodes.
 * Method for looking up data aims to avoid blocking rendering and use as
 * simple a lookup as possible.
 */
export default function collectSeats(seatEls, seatDataCollection) {
    // Build an array seat element IDs to match against.
    const seatElIds = map(seatEls, function(el) {
        return el.id;
    });

    /**
     * Filter out unwanted data from seat collections
     * 1. Remove display letters
     * 2. Remove entries with no seat number
     * 3. Remove entries with no seat row
     */
    const filteredSeatDataCollection = reject(seatDataCollection, data => {
        return (
            data.display_letter ||
            !data.seat_num ||
            !data.seat_row
        )
    });

    return new Promise(function(resolve) {
        let processed = [];
        let results = [];

        if (seatEls.length > 0) {
            processLargeArrayAsync(filteredSeatDataCollection, function(data) {
                /**
                 * 1. We try to disambiguate based on an (optional) additional section key.
                 * 2. Failing that we find a seat for the common seat selector key use that.
                 * 3. Finally, if we fail to match a seat report it to Sentry for review.
                 */
                const el = seatEls[seatElIds.indexOf(getSeatSelector(data))];
                const elWithSection = seatEls[seatElIds.indexOf(getSeatSelectorDisambiguated(data))];
                if (elWithSection) {
                    results.push({
                        el: elWithSection,
                        data: data
                    });
                } else if (el) {
                    results.push({
                        el: el,
                        data: data
                    });
                } else {
                    let unmatchedSeat = `seat ${data.seat_num}, row ${data.seat_row}, screen ${data.screen_no}`;
                    captureMessage(`Could not match seat: ${unmatchedSeat}`);
                }

                processed.push(data);

                if (processed.length === filteredSeatDataCollection.length) {
                    resolve(results);
                }
            })
        } else {
            resolve([]);
        }
    });
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seatmaps/collectSeats.js